import { render, staticRenderFns } from "./InsectDetector.vue?vue&type=template&id=453cde3f&scoped=true"
import script from "./InsectDetector.vue?vue&type=script&lang=js"
export * from "./InsectDetector.vue?vue&type=script&lang=js"
import style0 from "./InsectDetector.vue?vue&type=style&index=0&id=453cde3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cde3f",
  null
  
)

export default component.exports